import React, { useState, useEffect } from "react";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import SendIcon from "@mui/icons-material/Send";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import "../styles/ContactStyles.css";

export default function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setSubmitted(true);

    setTimeout(() => {
      setSubmitted(false);
    }, 4000);

    setForm({
      name: "",
      email: "",
      phone: "",
      subject: "",
      message: "",
    });
  };

  useEffect(() => {

    document.title =
      "Contact Us | Tecniqa";

  }, []);

  return (
    <div className="cp-root">

      {/* HERO */}

      <div className="cp-hero">

        <div className="cp-hero-grid" />

        <div className="cp-hero-orb cp-orb1" />
        <div className="cp-hero-orb cp-orb2" />

        <div className="cp-hero-content">

          <div className="cp-hero-badge">

            <div className="cp-hero-badge-dot" />

            Contact Tecniqa

          </div>

          <h1 className="cp-hero-title">

            Get In Touch
            <br />

            <span>With Our Team</span>

          </h1>

          <p className="cp-hero-sub">

            Need help with HVAC tools,
            cooling systems, product inquiries
            or bulk orders? Our certified team
            is available around the clock.

          </p>

        </div>

      </div>

      <div className="cp-body">

        {/* INFO ROW */}

        <div className="cp-info-row">

          {/* EMAIL */}

          <a
            href="mailto:support@tecniqa.com"
            className="cp-info-card"
          >
            <div className="cp-info-icon">
              <EmailIcon style={{ fontSize: 22 }} />
            </div>

            <div className="cp-info-text">
              <span className="cp-info-label">
                Email Us
              </span>

              <span className="cp-info-value">
                support@tecniqa.com
              </span>
            </div>
          </a>

          {/* PHONE */}

          <a
            href="tel:+919668246683"
            className="cp-info-card"
          >
            <div className="cp-info-icon">
              <PhoneIcon style={{ fontSize: 22 }} />
            </div>

            <div className="cp-info-text">
              <span className="cp-info-label">
                Call Us
              </span>

              <span className="cp-info-value">
                +91 9668 246 683
              </span>
            </div>
          </a>

          {/* LOCATION */}

          <a
            href="https://maps.app.goo.gl/xHz9MbPCBp7iBsfS8"
            target="_blank"
            rel="noopener noreferrer"
            className="cp-info-card"
          >
            <div className="cp-info-icon">
              <LocationOnIcon style={{ fontSize: 22 }} />
            </div>

            <div className="cp-info-text">
              <span className="cp-info-label">
                Visit Us
              </span>

              <span className="cp-info-value">
                Tecniqa | HVAC Solutions
              </span>
            </div>
          </a>

          {/* WORKING HOURS */}

          <div className="cp-info-card cp-info-card--no-link">
            <div className="cp-info-icon">
              <AccessTimeIcon style={{ fontSize: 22 }} />
            </div>

            <div className="cp-info-text">
              <span className="cp-info-label">
                Working Hours
              </span>

              <span className="cp-info-value">
                Mon – Sat, 9 AM – 6 PM
              </span>
            </div>
          </div>

        </div>

        {/* MAIN SECTION */}

        <div className="cp-main">

          {/* LEFT */}

          <div className="cp-form-wrap">

            <div className="cp-section-label">
              Send a Message
            </div>

            <h2 className="cp-section-title">
              We'd Love to Hear From You
            </h2>

            <p className="cp-section-sub">
              Fill out the form and our team will get back to you within 24 hours.
            </p>

            {submitted && (
              <div className="cp-success">
                ✓ Message sent! We'll be in touch shortly.
              </div>
            )}

            <form
              className="cp-form"
              onSubmit={handleSubmit}
            >

              {/* ROW 1 */}

              <div className="cp-form-row">

                <div className="cp-field">
                  <label className="cp-label">
                    Full Name *
                  </label>

                  <input
                    className="cp-input"
                    type="text"
                    name="name"
                    placeholder="John Doe"
                    value={form.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="cp-field">
                  <label className="cp-label">
                    Email Address *
                  </label>

                  <input
                    className="cp-input"
                    type="email"
                    name="email"
                    placeholder="john@example.com"
                    value={form.email}
                    onChange={handleChange}
                    required
                  />
                </div>

              </div>

              {/* ROW 2 */}

              <div className="cp-form-row">

                <div className="cp-field">
                  <label className="cp-label">
                    Phone Number
                  </label>

                  <input
                    className="cp-input"
                    type="tel"
                    name="phone"
                    placeholder="+91 XXXXX XXXXX"
                    value={form.phone}
                    onChange={handleChange}
                  />
                </div>

                <div className="cp-field">
                  <label className="cp-label">
                    Subject *
                  </label>

                  <select
                    className="cp-input cp-select"
                    name="subject"
                    value={form.subject}
                    onChange={handleChange}
                    required
                  >
                    <option value="" disabled>
                      Select a subject
                    </option>

                    <option>Product Enquiry</option>
                    <option>Get a Quote</option>
                    <option>Technical Support</option>
                    <option>Order & Shipping</option>
                    <option>Other</option>
                  </select>
                </div>

              </div>

              {/* MESSAGE */}

              <div className="cp-field">
                <label className="cp-label">
                  Message *
                </label>

                <textarea
                  className="cp-input cp-textarea"
                  name="message"
                  placeholder="Tell us how we can help you..."
                  rows={5}
                  value={form.message}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* BUTTON */}

              <button
                className="cp-submit"
                type="submit"
              >
                <SendIcon style={{ fontSize: 16 }} />
                Send Message
              </button>

            </form>
          </div>

          {/* RIGHT */}

          <div className="cp-right">

            {/* MAP */}

            <div className="cp-map-wrap">

              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d946.7612897292429!2d85.1014188728373!3d20.84047041362609!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a18affc0ae810ad%3A0x6be28b1cec18b640!2sR4R2%2B6H7%2C%20004%2C%206th%20Ln%2C%20behind%20hotel%20shakti%20Near%20hanuman%20temple%2C%20Amalapada%2C%20Angul%2C%20Odisha%20759122!5e1!3m2!1sen!2sin!4v1782471194342!5m2!1sen!2sin"
                loading="lazy"
                allowFullScreen
                title="Tecniqa Location"
              />

              <div className="cp-map-badge">
                <LocationOnIcon style={{ fontSize: 14 }} />
                DLF Cyber City, Bhubaneswar
              </div>

            </div>

            {/* SIDEBAR */}

            <div className="cp-sidebar-card">

              <h4 className="cp-sidebar-title">
                Why Choose Tecniqa?
              </h4>

              <ul className="cp-sidebar-list">
                <li>
                  <span className="cp-check">✓</span>
                  ISO Certified Products
                </li>

                <li>
                  <span className="cp-check">✓</span>
                  Pan-India Delivery
                </li>

                <li>
                  <span className="cp-check">✓</span>
                  Expert Technical Support
                </li>

                <li>
                  <span className="cp-check">✓</span>
                  Genuine Brand Warranty
                </li>

                <li>
                  <span className="cp-check">✓</span>
                  Competitive Pricing
                </li>
              </ul>

            </div>

          </div>

        </div>
      </div>
    </div>
  );
}